import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { formValues } from 'redux-form';
import { branch, renderNothing, mapProps } from 'recompose';
import { formatAmount } from 'common/utils/format';
import { fundingTypes } from 'common/choices';
import computeInvestment from 'common/model/simulation/scpi/computeInvestment';
import FormGroup from 'components/form/Group';
import { GridLayout } from 'components/form/layout';
import { ChoiceField, PercentageField, IntegerField, DisabledField } from 'components/form/field';
import Title from 'components/Title';
import LifeInsurance from './LifeInsurance';

const FundingInner = ({ type, fundingAmount, namePrefix = 'data' }) => {
    const isRecommendation = namePrefix.includes('recommendationsCIF');

    return (
        <Fragment>
            <FormGroup>
                <Title><b>Financement</b></Title>
                <GridLayout className="triple condensed">
                    <IntegerField
                        name={`${namePrefix}.funding.personalContribution`}
                        title="Montant de l'apport personnel"
                        min={0}
                    />
                    <IntegerField
                        name={`${namePrefix}.funding.brokerageFees`}
                        title="Frais d'ingénierie"
                        min={0}
                    />
                    <DisabledField
                        value={formatAmount(fundingAmount)}
                        title="Montant du prêt"
                        name={`${namePrefix}.funding.fundingAmount`}
                    />
                    <IntegerField
                        name={`${namePrefix}.funding.duration`}
                        title="Durée (mois)"
                        min={10}
                        required
                    />
                    {isRecommendation ?
                        <DisabledField
                            name={`${namePrefix}.funding.type`}
                            title="Type"
                            value="Amortissable"
                        /> :
                        <ChoiceField
                            choices={fundingTypes}
                            name={`${namePrefix}.funding.type`}
                            title="Type"
                            double
                            required
                        />
                    }
                    <PercentageField
                        name={`${namePrefix}.funding.rate`}
                        title="TAEG"
                        required
                    />
                </GridLayout>
            </FormGroup>
            {'in-fine' === type ? <LifeInsurance capital={fundingAmount} /> : null}
        </Fragment>
    );
};

FundingInner.propTypes = {
    type: PropTypes.string,
    fundingAmount: PropTypes.number.isRequired,
    namePrefix: PropTypes.string,
};

FundingInner.defaultProps = {
    type: null,
    namePrefix: 'data',
};

const Funding = flowRight([
    formValues(({ namePrefix = 'data' }) => ({
        needFunding: `${namePrefix}.needFunding`,
        type: `${namePrefix}.funding.type`,
        personalContribution: `${namePrefix}.funding.personalContribution`,
        brokerageFees: `${namePrefix}.funding.brokerageFees`,
        products: `${namePrefix}.products`,
    })),
    branch(({ needFunding }) => !needFunding, renderNothing),
    mapProps(({ personalContribution, brokerageFees, products, type, namePrefix = 'data' }) => ({
        fundingAmount: computeInvestment(products) + (brokerageFees - personalContribution),
        type,
        namePrefix,
    })),
])(FundingInner);

export default Funding;
